.icon_container {
  align-items: center;
  cursor: inherit;
  display: flex;
  height: var(--icon-height);
  justify-content: center;
  outline: none;
  position: relative;
  margin-bottom: var(--margin-bottom);
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  text-align: center;
  width: var(--icon-width);
}

.icon_container:focus-visible::after {
  position: absolute;
  content: '';
  display: inherit;
  top: -4px;
  left: -4px;
  bottom: -4px;
  right: -4px;
  border: 2px solid var(--colors-primary-main);
  border-radius: var(--border-radius-lg);
  background-color: transparent;
}

.icon_container__pointer {
  cursor: pointer;
}

.icon {
  user-select: none;
  overflow: hidden;
  display: inline-block;
  text-align: center;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
}

.rotate-left {
  transform: rotate(-90deg);
}

.rotate-right {
  transform: rotate(90deg);
}

.rotate-down {
  transform: rotate(180deg);
}

.icon-stroke-color rect {
  stroke: var(--icon-stroke-color, currentColor);
}

.icon-stroke-color circle:not([class*='Fill-Main']) {
  stroke: var(--icon-stroke-color, currentColor);
}

.icon-fill-color path:not([class*='Details'], [class*='Fill-Accent']) {
  fill: var(--icon-fill-color, currentColor);
  fill-opacity: 1;
}

.icon-fill-color circle[class*='Fill-Main'] {
  fill: var(--icon-stroke-color, currentColor);
}

/* Sets icon detail paths to white on dark icons, black on light icons (lightness threshold: 0.6) */
.icon-contrast-compliant.icon-fill-color path[class*='Details'] {
  fill: oklch(
    from var(--icon-stroke-color, currentColor) clamp(0, (0.6 - l) * 999, 1) 0 0deg
  );
}
